// export const PORTAL_URL = "http://localhost:3000";
export const PORTAL_URL = window.location.origin;
export const BASE_URL = "https://hta.admin.developforlife.com";
// export const BASE_URL = "http://localhost:1337";
